"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var empty_api_key_graphic_svg_1 = __importDefault(require("@assets/components/apiintegration/empty-api-key-graphic/empty-api-key-graphic.svg"));
var plus_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/plus-icon.svg"));
var react_redux_1 = require("react-redux");
var actions_1 = __importDefault(require("../../actions"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c;
    return core_1.createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
            marginTop: theme.spacing(6),
            paddingTop: theme.spacing(5),
            marginBottom: theme.spacing(5),
            alignItems: 'center',
            backgroundColor: 'white',
        },
        emptyStateBodyText: {
            textAlign: 'center',
            marginTop: '41px',
        },
        createApiKeyButton: (_a = {
                width: '320px',
                minWidth: '90px',
                color: 'white',
                background: theme.palette.primary.main,
                padding: theme.spacing(2),
                fontWeight: 700,
                '&:hover': {
                    backgroundColor: theme.palette.primary.dark,
                }
            },
            _a[theme.breakpoints.down('sm')] = {
                width: 'auto',
            },
            _a),
        plusIcon: (_b = {
                width: '17px',
                marginLeft: 30
            },
            _b[theme.breakpoints.down('sm')] = {
                marginLeft: 10,
            },
            _b),
        emptyStateGraphic: {
            position: 'relative',
        },
        emptyStateGraphicImg: (_c = {
                maxWidth: 475
            },
            _c[theme.breakpoints.down('sm')] = {
                maxWidth: 275,
            },
            _c),
        link: {
            color: '#FFC700',
            fontWeight: 700,
        },
    });
});
/**
 * @component Default display component in place of api key generation.
 */
var NoApiKeyGraphic = function () {
    var t = react_i18next_1.useTranslation().t;
    var classes = useStyles();
    var dispatch = react_redux_1.useDispatch();
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(core_1.Button, { className: classes.createApiKeyButton, onClick: function () {
                dispatch(actions_1.default.generateApiKey());
            } },
            t('button.generateAPIKey'),
            "\u00A0",
            react_1.default.createElement("img", { className: classes.plusIcon, src: plus_icon_svg_1.default, alt: "generate api key" })),
        react_1.default.createElement(core_1.Typography, { variant: "body1", className: classes.emptyStateBodyText }, t('apiIntegration.message.beforGenerating')),
        react_1.default.createElement("div", { className: classes.emptyStateGraphic },
            react_1.default.createElement("img", { src: empty_api_key_graphic_svg_1.default, alt: "empty api key graphic", className: classes.emptyStateGraphicImg }))));
};
exports.default = NoApiKeyGraphic;
